// @ts-nocheck

/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@kubb/plugin-client/clients/axios";
import type { CreateInviteCreateInviteGetQueryResponse } from "../models/undefinedController/CreateInviteCreateInviteGet.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@kubb/plugin-client/clients/axios";

function getCreateInviteCreateInviteGetUrl() {
  const res = { method: 'GET', url: `/create_invite` as const }
  return res
}

/**
 * @summary Create Invite
 * {@link /create_invite}
 */
export async function createInviteCreateInviteGet(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<CreateInviteCreateInviteGetQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getCreateInviteCreateInviteGetUrl().url.toString(), ... requestConfig })
  return res.data
}